module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f44f.9fa091f6.svg";